import { Component } from '@angular/core';
import {
  ArithmeticActionType,
  ArithmeticOperationType,
  DataType,
  DecisionVertex,
  InterfaceDirectionType,
  TransformationType,
  Workflow,
  WorkflowFactory,
  WorkflowVertexType
} from 'component.workflow.core';

@Component({
  selector: 'wf-root',
  template: `
    <buzzyears-root [header]="false" [sidebar]="false">
      <router-outlet></router-outlet>
    </buzzyears-root>
  `,
  styles: []
})
export class AppComponent {

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts